import { render } from "./FileErrorComponent.vue?vue&type=template&id=38fb0056&scoped=true"
import script from "./FileErrorComponent.vue?vue&type=script&lang=js"
export * from "./FileErrorComponent.vue?vue&type=script&lang=js"

import "./FileErrorComponent.vue?vue&type=style&index=0&id=38fb0056&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fb0056"]])

export default __exports__